export default function Node_NPM() {
  return <div>Node_NPM Component</div>;
}
